import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="universe-switcher"
export default class extends Controller {
  static targets = ["select", "indicator"]

  connect() {
    if (this.hasSelectTarget) {
      // Controller is connected to a select element (sidebar)
    } else {
      // Controller is connected to buttons (topbar)
      this.updateActiveUniverse()
    }
  }

  // Handle select change (sidebar)
  change(event) {
    const universe = event.target.value
    this.navigateToUniverse(universe)
  }

  // Handle button click (topbar)
  switchUniverse(event) {
    const universeKey = event.currentTarget.dataset.universe

    // Add smooth transition effect
    this.element.classList.add('transitioning')

    // Store user's preferred universe
    localStorage.setItem('preferred_universe', universeKey)

    setTimeout(() => {
      this.element.classList.remove('transitioning')
    }, 300)
  }

  navigateToUniverse(universe) {
    const routes = {
      admin: '/admin',
      crm: '/admin/crm/dashboard',
      support: '/admin/support/tickets'
    }

    if (routes[universe]) {
      // Store user's preferred universe
      localStorage.setItem('preferred_universe', universe)

      // Navigate to the universe
      window.location.href = routes[universe]
    }
  }

  updateActiveUniverse() {
    const activeButton = this.element.querySelector('[data-universe].bg-blue-50, [data-universe].bg-orange-50, [data-universe].bg-purple-50, [data-universe].bg-green-50')

    if (activeButton) {
      // Animate the active indicator
      const indicator = activeButton.querySelector('.absolute.-bottom-px')
      if (indicator) {
        indicator.style.transform = 'translateX(-50%) scaleX(0)'
        requestAnimationFrame(() => {
          indicator.style.transition = 'transform 0.3s ease-out'
          indicator.style.transform = 'translateX(-50%) scaleX(1)'
        })
      }
    }
  }
}